/**
 * Contextual help affordance (? icon) — R-131-SUP-C
 */
// R-131-SUP-C
import React from 'react';
import { CircleHelp } from 'lucide-react';
import type { HelpSlug } from '../../lib/helpArticles';
import { useHelp } from './HelpProvider';

interface Props {
  articleSlug: HelpSlug;
  /** Accessible label override. */
  label?: string;
  className?: string;
}

export function ContextualHelpButton({
  articleSlug,
  label = 'Open contextual help',
  className,
}: Props): React.ReactElement {
  const { openDrawer } = useHelp();

  return (
    <button
      type="button"
      onClick={() => openDrawer(articleSlug)}
      className={
        className ??
        'inline-flex items-center justify-center w-7 h-7 rounded-full border border-border text-text-secondary hover:text-text-primary hover:bg-state-hover transition-colors'
      }
      title={label}
      aria-label={label}
      data-testid={`contextual-help-${articleSlug}`}
    >
      <CircleHelp className="w-4 h-4" aria-hidden />
    </button>
  );
}
